import script from "./UserQuestionFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionFormView.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionFormView.vue?vue&type=style&index=0&id=2bd2cdbc&lang=scss"

const __exports__ = script;

export default __exports__